export default "./a69aeed83f5434abf3766218b0a14771.webp";